import Trans from 'next-translate/Trans'
import noFiller from '../../../../public/assets/illustration-fillers.svg'
import noPreservatives from '../../../../public/assets/illustration-preservatives.svg'
import humanelyHarvested from '../../../../public/assets/illustration-heart-clean.svg'
import noAddedAntibiotics from '../../../../public/assets/illustration-paw-clean.svg'
import useTranslation from 'next-translate/useTranslation'
import { FeatureColumn, IconContainer } from '../OurStory.styles'
import Image from 'next/image'
import { Text } from 'components/Text'

export const Features = () => {
  const { t } = useTranslation()
  return (
    <>
      <FeatureColumn>
        <IconContainer adjusted="small">
          <Image src={noFiller} alt={t('our-story:meet-meat.icon-info.title-1')} />
        </IconContainer>
        <Text
          css={{ lineHeight: '1.25' }}
          size={{ '@initial': 'body', '@bp2': 'body' }}
          align="center"
          color="accent-black"
        >
          <Trans components={{ br: <br /> }} i18nKey={'our-story:meet-meat.icon-info.title-1'} />
        </Text>
      </FeatureColumn>
      <FeatureColumn>
        <IconContainer>
          <Image src={noPreservatives} alt={t('our-story:meet-meat.icon-info.title-2')} />
        </IconContainer>
        <Text
          css={{ lineHeight: '1.25' }}
          size={{ '@initial': 'body', '@bp2': 'body' }}
          align="center"
          color="accent-black"
        >
          <Trans components={{ br: <br /> }} i18nKey={'our-story:meet-meat.icon-info.title-2'} />
        </Text>
      </FeatureColumn>
      <FeatureColumn>
        <IconContainer adjusted="tiny">
          <Image src={humanelyHarvested} alt={t('our-story:meet-meat.icon-info.title-3')} />
        </IconContainer>
        <Text
          css={{ lineHeight: '1.25' }}
          size={{ '@initial': 'body', '@bp2': 'body' }}
          align="center"
          color="accent-black"
        >
          <Trans components={{ br: <br /> }} i18nKey={'our-story:meet-meat.icon-info.title-3'} />
        </Text>
      </FeatureColumn>
      <FeatureColumn>
        <IconContainer>
          <Image src={noAddedAntibiotics} alt={t('our-story:meet-meat.icon-info.title-4')} />
        </IconContainer>
        <Text
          css={{ lineHeight: '1.25' }}
          size={{ '@initial': 'body', '@bp2': 'body' }}
          align="center"
          color="accent-black"
        >
          <Trans components={{ br: <br /> }} i18nKey={'our-story:meet-meat.icon-info.title-4'} />
        </Text>
      </FeatureColumn>
    </>
  )
}
